import { useState } from 'react'
import { Link } from 'react-router-dom'
import axios from 'axios'
import AuthShell from '../../components/common/AuthShell'

export default function ResendVerification() {
  const [email, setEmail] = useState('')
  const [loading, setLoading] = useState(false)
  const [success, setSuccess] = useState(false)
  const [error, setError] = useState('')

  const handleSubmit = async (e) => {
    e.preventDefault()
    setError('')
    setLoading(true)

    try {
      await axios.post('http://localhost:8000/api/v1/auth/resend-verification', { email })
      setSuccess(true)
    } catch (err) {
      // Rate limit error
      if (err.response?.status === 429) {
        setError('Zu viele Anfragen. Bitte versuchen Sie es später erneut.')
      } else {
        setError('Ein Fehler ist aufgetreten. Bitte versuchen Sie es erneut.')
      }
    } finally {
      setLoading(false)
    }
  }

  if (success) {
    return (
      <AuthShell
        title="E-Mail gesendet!"
        subtitle="Falls Ihr Account noch nicht verifiziert ist, haben wir Ihnen einen neuen Verifizierungs-Link gesendet."
      >
        <p className="wc-muted" style={{ fontSize: 13, margin: 0 }}>
          Bitte überprüfen Sie Ihr E-Mail-Postfach (auch den Spam-Ordner).
          Der Link ist 24 Stunden gültig.
        </p>
        <Link to="/login" className="wc-btn wc-btn-primary wc-btn-block">
          Zum Login
        </Link>
      </AuthShell>
    )
  }

  return (
    <AuthShell
      title="Verifizierungs-E-Mail erneut senden"
      subtitle="Geben Sie Ihre E-Mail-Adresse ein und wir senden Ihnen einen neuen Verifizierungs-Link."
    >
      <form onSubmit={handleSubmit} style={{ display: 'grid', gap: 16 }}>
        {error && (
          <div className="wc-alert wc-alert-error" role="alert">
            {error}
          </div>
        )}

        <div className="wc-field">
          <label htmlFor="email">E-Mail-Adresse</label>
          <input
            id="email"
            name="email"
            type="email"
            autoComplete="email"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="wc-input"
            placeholder="ihre-email@beispiel.de"
          />
        </div>

        <button
          type="submit"
          disabled={loading}
          className="wc-btn wc-btn-primary wc-btn-block"
        >
          {loading ? 'Wird gesendet…' : 'Verifizierungs-Link senden'}
        </button>
      </form>

      <div className="wc-hr" style={{ margin: 0 }}></div>

      <div style={{ textAlign: 'center', fontSize: 14 }}>
        <Link to="/login">Zurück zum Login</Link>
      </div>
    </AuthShell>
  )
}
